export default {"src":"/_next/static/media/chevron-down.2b92ed02.svg","height":9,"width":14};